module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-vehicle-list row column"
  }, [_c('cards', {
    attrs: {
      "data": _vm.parsedReports
    }
  }), _c('vehicle-list-form', {
    on: {
      "filterVehicles": _vm.setSearch
    }
  }), _c('base-list', {
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "search": _vm.search
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-768202ed!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/VehicleList.vue
// module id = 2607
// module chunks = 1